<template>
  <div class="view-content view10">
    <div class="left">
      <div class="title">{{ $t('团队及投资人') }}</div>
      <div class="text text-padding">{{ $t('全球化视野 · 多元化背景。') }}</div>
      <div class="label">{{ $t('NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。') }}</div>
    </div>
    <div class="right">
      <div class="tab">
        <div class="tab-item" v-for="(item, index) in tabList" :key="index" :class="{'active': item.id == currentTab}" @click="currentTab = item.id">{{ item.title }}</div>
      </div>
      <div class="tab-content-investor">
        <div v-show="currentTab == 'investor'" class="tab-item-investor" v-for="(item, index) in investorList" :key="index">
          <img :src="item.img" class="investor-img">
        </div>
      </div>
      <div class="tab-content-operator">
        <div v-show="currentTab == 'operator'" class="tab-item-operator" v-for="(item, index) in operatorList" :key="index">
          <img :src="item.img" class="operator-img">
          <div class="operator-info">
            <div class="title">{{ item.title }}</div>
            <div class="tag">{{ item.tag }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view10',
  data () {
    return {
        currentTab: "investor",
        tabList: [
            {
                id: "investor",
                title: this.$t('投资人'),
            },
            {
                id: "operator",
                title: this.$t('运营团队'),
            },
        ],
        investorList: [
            {
                img: require('./img/1030/view10-1.png'),
            },
            {
                img: require('./img/1030/view10-2.png'),
            },
            {
                img: require('./img/1030/view10-3.png'),
            },
            {
                img: require('./img/1030/view10-4.png'),
            },
        ],
        operatorList: [
            {
                img: require('./img/1030/view10-5.png'),
                title: this.$t('Moe Farmani'),
                tag: 'CEO',
                text: this.$t('拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者'),
            },
            {
                img: require('./img/1030/view10-6.png'),
                title: this.$t('Matt Romman'),
                tag: 'COO',
                text: this.$t('从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。'),
            },
            {
                img: require('./img/1030/view10-7.png'),
                title: this.$t('Alex Eric'),
                tag: 'CSO',
                text: this.$t('曾任职OKX，负责公司品牌和战略'),
            },
            {
                img: require('./img/1030/view10-8.png'),
                title: this.$t('Manoharlal'),
                tag: 'CTO',
                text: this.$t('Novai Chain Founder， 全面支撑NECO技术落地。'),
            }
        ],
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";

.view10 {
    flex-direction: column;
    justify-content: center;
}

.view10 .label {
    padding-top: 0;
}

.view10 .label {
    padding-right: 200px;
    color: #fff;
}

.view10 .left {
    flex: none;
    width: 100%;

}

.view10 .right {
    width: 100%;
    padding-top: 60px;
}

.tab-content-investor {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
}

.tab-content-operator {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
}

.tab {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
}

.tab-item {
    border: 1px solid #07C160;
    padding: 10px 24px;
    gap: 10px;
    cursor: pointer;
}

.active {
    background: #07C160;
}

.tab-item-investor {
    padding-top: 108px;
    height: 82px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}

.investor-img {
    width: 100%;
    height: 82px;
}

.tab-item-operator {
    flex: 1;
    align-self: stretch;
    background: rgba(255, 255, 255, 0.10);
    padding: 30px 23px 21px 15px;
    box-sizing: border-box;
    display: flex;
}

.operator-img {
    width: 106px;
    height: 106px;
    border-radius: 106px;
}

.operator-info {
    flex: 1;
    padding-left: 14px;
    box-sizing: border-box;
}

.tab-item-operator .title {
    font-size: 24px;
    font-weight: 600;
}

.tab-item-operator .tag {
    padding: 2px 10px;
    gap: 10px;
    background: #07C160;
    margin: 4px 0 18px;
    width: fit-content;
}

.tab-item-operator .text {
    font-size: 16px;
    font-weight: 600;
}

@media screen and (max-width: 768px) {
    .view10 {

    }
    .tab {
        width: 100%;
    }
    .view10 .right {
        padding-top: 0;
    }
    .tab-item {
        font-size: 14px;
        flex: 1;
        text-align: center;
    }
    .tab-content-investor {
        flex-wrap: wrap;
    }
    .tab-item-investor {
        padding-top: 0;
        margin-bottom: 0.5rem;
        
    }
    .investor-img {
        height: 50px;
    }
    .tab-content-operator {
        overflow-x: auto;
    }
    .tab-item-operator {
        display: block;
        flex: none;
        width: 60%;
        background: none;
        text-align: center;
    }
    .tab-item-operator .tag {
        font-size: 16px;
        margin: 4px auto 18px;
    }
    .operator-img {
        width: 2rem;
        height: 2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view10.vue